"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fallbackUntilMatch = exports.countTilesByPricingProduct = exports.hashTilePricingProduct = exports.isPricingProductsEqual = exports.fallBackPricingProduct = exports.PRICING_ITEMS_FALLBACK_COUNT = void 0;
const tiles_1 = require("../consts/tiles");
const pricing_1 = require("../consts/pricing");
const normalizePricingProduct = (tile) => {
    const pricingProduct = {
        tileSize: tile.tileSize,
    };
    // to avoid key:undefined, which causes tests to fail on deep compare.
    // We also ignore classic material type as it's the default (as well as for backward compatability)
    if (tile.materialType && tile.materialType !== tiles_1.MATERIAL_TYPES.CLASSIC) {
        pricingProduct.materialType = tile.materialType;
    }
    if (tile.frameColor) {
        // always set materialType when frame color exists
        pricingProduct.materialType = tile.materialType;
        pricingProduct.frameColor = tile.frameColor;
    }
    return pricingProduct;
};
// Fallback a Pricing Items by order, for example if 4X4-frame-white is missing, use 4X4-frame price
const FALLBACK_ORDER = ['frameColor', 'materialType'];
exports.PRICING_ITEMS_FALLBACK_COUNT = FALLBACK_ORDER.length;
function fallBackPricingProduct(pricingProduct) {
    const key = FALLBACK_ORDER.find((key) => pricingProduct[key]);
    if (!key)
        return pricingProduct;
    const fallback = Object.assign({}, pricingProduct);
    delete fallback[key];
    return fallback;
}
exports.fallBackPricingProduct = fallBackPricingProduct;
function isPricingProductsEqual(pricingProduct1, pricingProduct2) {
    return hashTilePricingProduct(pricingProduct1) === hashTilePricingProduct(pricingProduct2);
}
exports.isPricingProductsEqual = isPricingProductsEqual;
function hashTilePricingProduct(pricingProduct) {
    if (!pricingProduct)
        return null;
    const normalizedPricingProduct = normalizePricingProduct(pricingProduct);
    // For backward compatability due to potential usage in all sort of hard coded mapping
    // emulates the getTileSKU function
    if (!normalizedPricingProduct.materialType && !normalizedPricingProduct.frameColor) {
        return normalizedPricingProduct.tileSize;
    }
    if (!normalizedPricingProduct.frameColor) {
        return `${normalizedPricingProduct.tileSize}-${normalizedPricingProduct.materialType}`;
    }
    return `${normalizedPricingProduct.tileSize}-${normalizedPricingProduct.materialType}-${normalizedPricingProduct.frameColor}`;
}
exports.hashTilePricingProduct = hashTilePricingProduct;
const countTilesByPricingProduct = ({ tiles, }) => {
    const productQuantities = tiles.reduce((acc, pricingProduct) => {
        const hash = hashTilePricingProduct(pricingProduct);
        if (!acc[hash]) {
            acc[hash] = {
                id: pricing_1.ProductIds.SKU_TILES,
                quantity: 1,
                pricingProduct: normalizePricingProduct(pricingProduct),
            };
        }
        else {
            acc[hash].quantity++;
        }
        return acc;
    }, {});
    return Object.values(productQuantities);
};
exports.countTilesByPricingProduct = countTilesByPricingProduct;
function fallbackUntilMatch(pricingProduct, matchFunction) {
    if (matchFunction(pricingProduct)) {
        return matchFunction(pricingProduct);
    }
    while (pricingProduct !== fallBackPricingProduct(pricingProduct)) {
        pricingProduct = fallBackPricingProduct(pricingProduct);
        if (matchFunction(pricingProduct)) {
            return matchFunction(pricingProduct);
        }
    }
    return null;
}
exports.fallbackUntilMatch = fallbackUntilMatch;
//# sourceMappingURL=tilesPricer.js.map